<template>
  <div class="homeDetail">
    <img src="../assets/imgs/homeBg.jpg" alt="" />
    <div
      class="back"
      @click="$router.go(-1)"
    >
      <img src="../assets/imgs/detail2.png" alt="back" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addBackClass: "",
    };
  },
  methods: {
    addClassName(type, name) {
      this.addBackClass = name;
    },
  },
};
</script>

<style lang="scss" scoped>
.homeDetail{
  position: relative;
}
.back {
  position: absolute;
  left: 70px;
  bottom: 70px;
  width: 255px;
  height: 58px;
  transform: scale(0.7) !important;
  cursor: pointer;
  img{
    transition: All 200ms ease-in-out;
  }
  img:hover{
    transform: scale(1.1) !important;
  }
}
</style>